module.exports = __webpack_public_path__ + "img/weddings_09_V.87840f68.webp";